import TripDrawer, { type TripDrawerAnimation } from 'tripPlanner/components/GenericDrawer/TripDrawer'
import TripDrawerHeaderTitle from 'tripPlanner/components/GenericDrawer/TripDrawerHeaderTitle'
import {
  shouldRenderTripDrawerTitleInContent,
  useRightPanelTripDrawerPresentation,
} from 'tripPlanner/components/GenericDrawer/TripDrawerPresentationContext'
import DrawerDetailLoadingSkeleton from './DrawerDetailLoadingSkeleton'

interface Props {
  isOpen: boolean
  onClose: () => void
  onAfterClose?: () => void
  onBack?: () => void
  animation?: TripDrawerAnimation
  placeName: string
}

function PendingPlaceDrawer({
  isOpen,
  onClose,
  onAfterClose,
  onBack,
  animation,
  placeName,
}: Props) {
  const drawerPresentation = useRightPanelTripDrawerPresentation()
  const showTitleInContent = shouldRenderTripDrawerTitleInContent(drawerPresentation)

  return (
    <TripDrawer
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={onAfterClose}
      onBack={onBack}
      animation={animation}
      direction="right-to-left"
      presentation={drawerPresentation}
      header={
        !showTitleInContent ? (
          <TripDrawerHeaderTitle title={placeName} />
        ) : undefined
      }
    >
      <DrawerDetailLoadingSkeleton title={showTitleInContent ? placeName : undefined} />
    </TripDrawer>
  )
}

export default PendingPlaceDrawer
